/**
 * 객체 배열의 특정 프로퍼티 값의 합계
 * @param {*} objArray
 * @param {*} propertyName
 * @returns
 */
export const sumByPropertyName = (objArray, propertyName) => {
  return objArray.reduce((acc, cur) => acc + cur[propertyName], 0)
}

/**
 * ex 0.12 -> 12%
 * @param {*} num
 * @returns
 */
export const toPercentage = (num, toFixed = 1) => {
  return (num * 100).toFixed(toFixed)
}

/**
 * 소수점자리 값 없으면 소수점자리 제거 및
 * 0으로 끝나면 0 제거
 *
 * @example
 * 19.55 -> 19.55
 * 19.50 -> 19.5
 * 19.0 -> 19
 *
 * @param {*} value
 * @returns
 */
export const trimDecimalZeros = (value) => {
  return Number(value)
    .toString()
    .replace(/(\.\d*?)0+$/, '$1')
}

/**
 * 숫자 select box 생성용
 * @param {*} start
 * @param {*} end
 * @param {*} reverse boolean
 * @returns [start ... end]
 */
export const generateRange = (start, end, reverse) => {
  const range = Array.from({ length: end - start + 1 }, (_, index) => start + index)
  return reverse ? range.reverse() : range
}
